module.exports = __webpack_public_path__ + "static/curiosity-c4ce6e5fa4f8498a328b59f25e0efb11.png";